export enum PayPalEnvironmentType {
    Sandbox,
    Production,
}

export class PayPalPaymentConfig {
    public allowPayPalPayments?: boolean;
    public clientId?: string;
    public environment?: PayPalEnvironmentType;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): PayPalPaymentConfig {
        const payPalPaymentConfig: PayPalPaymentConfig = new PayPalPaymentConfig();

        payPalPaymentConfig.allowPayPalPayments = this.allowPayPalPayments;
        payPalPaymentConfig.clientId = this.clientId;
        payPalPaymentConfig.environment = this.environment;

        return payPalPaymentConfig;
    }
}
